import React, { Component } from 'react';
import Select from "react-select";
//import { Button, Input } from "reactstrap"
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/light.css";
import InputMask from "react-input-mask";
import commonApiFunction, { uploadImageFileFunction } from "../../../api/ApiController";
import { Growl } from 'primereact/growl';
import HeaderRegistration from '../../common/headers/header-registration';
import FooterCustom from "../../common/footers/footer-custom";
import { Helmet } from 'react-helmet'
import SimpleReactValidator from 'simple-react-validator';

import {
    Card,
    CardBody,
    CardHeader,
    Input,
    Button, Col, Row, Label, FormGroup, Alert, FormText, InputGroup, InputGroupAddon
} from "reactstrap";

import WindowedSelect from "react-windowed-select";
import CreatableSelect from "react-select/creatable";
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { AutoComplete } from 'primereact/autocomplete';
import { history } from '../../history';

import { commonpostApiFunction, commongetApiFunction, uploadImageFileFunctionRest } from "../../../resources/ApiController"

import { Check, TrendingUp, Upload } from "react-feather";

import { Redirect } from 'react-router-dom';
import { AlertCircle, AlertTriangle, CheckCircle } from 'react-feather'
import LSDatePicker from "../../datePicker/LSDatePicker.js";
import LSDatePicker2 from "../../datePicker/LSDatePicker2.js";
import SweetAlert from 'react-bootstrap-sweetalert';

import moment from "moment"
import ReactTooltip from "react-tooltip";
import * as Icon from "react-feather";
import { FreezeUI, UnfreezeUI } from '../../../assets/js/freeze-ui';
const country = [
    { value: "United States", label: "United States" }
]

const formatChars = {
    n: '[0-1]',
    m: '[0-9]',
    e: '[0-3]',
    d: '[0-9]',
    z: '[1-2]',
    y: '[0-9]'
}

const currentYear = new Date().getFullYear();
const previousYear = currentYear - 1;
const yearOptions = [
    { value: previousYear, label: previousYear, },
    { value: currentYear, label: currentYear, },
]

const inputids = [

    { value: "FirstName", id: "PatientFirstName", type: "input" },
    { value: "LastName", id: "PatientLastName", type: "input" },
    { value: "Gender", id: "react-select-2-input", type: "select" },
    { value: "Date of Birth", id: "LSDatePicker", type: "input" },
    { value: "Race", id: "react-select-3-input", type: "select" },
    { value: "Ethnicity", id: "react-select-4-input", type: "select" },
    { value: "Sexual Orientation", id: "react-select-5-input", type: "select" },

    { value: "Cell Phone", id: "patient_cell_phone", type: "input" },
    { value: "EmailID", id: "PatientEmailID", type: "select" },
    { value: "Address1", id: "patient_case_address_line_1", type: "input" },
    { value: "State", id: "react-select-6-input", type: "select" },
    { value: "City", id: "react-select-7-input", type: "select" },
    { value: "zip", id: "patient_zipcode", type: "select" },
    { value: "InsuranceCompany", id: "react-select-9-input", type: "select" },
    // { value: "Insured Date of Birth", id: "LSDatePicker", type: "select" },
    { value: "Relationship to Subscriber", id: "react-select-10-input", type: "select" },

]




const TimingSlot = [

    { Day: "Mondays",DayValue:1, From: "9:00 AM", To: "2:00 PM" },
    { Day: "Tuesdays",DayValue:2, From: "9:00 AM", To: "2:00 PM" },
    { Day: "Wednesdays",DayValue:3, From: "9:00 AM", To: "2:00 PM" },
    { Day: "Thursdays",DayValue:4, From: "9:00 AM", To: "2:00 PM" },
    { Day: "Fridays",DayValue:5, From: "9:00 AM", To: "2:00 PM" },

]

// const TimingSlot = [

//     { Day: "Mondays",DayValue:1, From: "7:15 AM", To: "2:45 PM" },
//     { Day: "Tuesdays",DayValue:2, From: "8:45 AM", To: "4:15 PM" },
//     { Day: "Wednesdays",DayValue:3, From: "7:15 AM", To: "2:45 PM" },
//     { Day: "Thursdays",DayValue:4, From: "8:45 AM", To: "4:15 PM" },
//     { Day: "Fridays",DayValue:5, From: "7:15 AM", To: "2:45 PM" },

// ]

class PreRegistration extends Component {

    constructor(props) {
        super(props);

        let currentTimestamp = Date.now();
        let date = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(currentTimestamp);
        let time = new Intl.DateTimeFormat('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(currentTimestamp)

        this.state = {
            data: [],
            selectedData: [],
            userData: [],
            redirect: '',
            isExpired: false,
            providerJWTData: [],
            loading: true,
            decodedToken: [],
            isSessionTimedOut: 0,
            jwtToken: [],
            curTime: date + "__" + time,
            selected_patient_dob: undefined,
            selected_InsuredDOB: undefined,
            valAgeType: [{ label: 'Year', value: 'Year' }],
            nm_agetype: 'Year',
            AppointmentPlaceResponse: '',
            PatientFirstName: '',
            PatientMiddleName: '',
            PatientLastName: '',
            patient_gender: '',
            valGender: [],
            patient_ethnicity: '',
            patient_cell_phone: '',
            patient_home_phone: '',
            patient_ssn: '',
            patient_race: '',
            patient_case_address_line_1: '',
            patient_case_address_line_2: '',
            statename: '',
            patient_city: '',
            StateId: '',
            countryData: [],

            stateData: [],
            cityData: [],
            races: [],
            ethnicity: [],
            SexualOrientation: [],
            patient_sexual_orientation: '',
            RaceID: '',
            RaceName: '',
            valRace: [],
            valEthnicity: [],
            valState: [],
            valCity: [],
            pstate: '',
            patient_country: 'United States',

            RelationshipData: [],
            valRelationshipData: [],
            valLabTest: [],
            TestData: [],
            InsuranceDoc: [],
            CompleteName: '',
            InsurancePlan: '',
            InsuranceCode: '',
            InsuranceManagerDetailID: '',
            valInsuranceCompany: [],
            InsuranceCompanyData: [],
            iInsuredName: '',
            iPlanCode: '',
            iCompany: '',
            iAddress: '',
            iId: '',
            iGroup: '',
            InsuranceCompanyID: '',
            InsuredRelationshipID: '',
            Age: '',
            patient_requisition_number: '',
            patient_zipcode: '',
            successAlert: false,
            sweetAlertTitle: '',
            errorAlert: false,
            fileTypeErr: false,
            showSuccessAlert: false,
            showErrorAlert: false,
            isButtonDisabled: false,
            lastnames: [],
            showLink: 0,
            patient_gender_id: '',
            GenderList: [],
            InsuranceDocument: [],
            cash_payment: '',
            ap_test_time: '',
            ap_test_day: '',
            selectedFile: "",
            selected_ap_test_day:'',
            TimeData: [],
            valTestTime: [],
            TimeSlotData:[],

        }
        this.handle_saveAppointment = this.handle_saveAppointment.bind(this);
        this.uploadValidator = new SimpleReactValidator({ autoForceUpdate: this });

        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            validators: {
                InvalidWeekend: {  // name the rule
                    message: 'The :attribute is not valid',
                    rule: (val, params, validator) => {//date.getDay() === 0 || date.getDay() === 6
					//console.log(val);
                        if (val == "Invalid Date" || val == null) {
                            return false;
                        }
                        else if ((new Date(val)).getDay()  === 0 || (new Date(val)).getDay()=== 6) {
                            return false;
                        }
                            else {

                                return true;
                            }
                        
                    },
                },
                InvalidDOB: {  // name the rule
                    message: 'The :attribute is not valid',
                    rule: (val, params, validator) => {
                        if (val == "Invalid Date" || val == null) {
                            return false;
                        }
                        else {
                            if (new Date(val) > new Date()) {

                                return false;
                            }
                            else {

                                return true;
                            }
                        }
                    },
                },
                InvalidName: {
                    message: 'The name should contain atleast one character',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^.*[a-zA-Z]+.*$/)
                    }
                },
                InvalidPhone: {
                    message: 'The phone number field is invalid',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[\d ()+-]+$/)
                    }
                },
                InvalidLMP: {  // name the rule
                    message: 'The :attribute is not valid',
                    rule: (val, params, validator) => {
                        if (val == "Invalid Date" || val == null) {
                            return false;
                        }
                        else {
                            if (new Date(val) > new Date()) {

                                return false;
                            }
                            else {

                                return true;
                            }
                        }
                    },
                },
            }
        });
    }

    componentDidMount() {

        this.getStateList()
        this.getGenderOptions()
        this.getRaces()
        this.getEthnicity();
        this.getSexualOrientation();

        this.uspGetRelationshipDetail();
        this.getInsuranceList();
        this.uspGetTestResult();
       // this.getTimes();

    }

    componentDidUpdate() {

    }





    getGenderOptions = () => {
        let params = {
            "token": ''
        }
        commonpostApiFunction('getGenderList', params, this.getGenderListResponse, this.onError);
    }
    getGenderListResponse = (response) => {
        this.setState({ GenderList: response.data.GenderList })
    }
    genderOptions() {
        return (this.state.GenderList.map(data => ({ label: data.GenderName, value: data.GenderValue, key: data.GenderDetailID })))
    }

    /////////////// Messages /////////////////////
    fnshowSuccessAlert = () => {
        this.setState({ showSuccessAlert: true }, () => {
            window.setTimeout(() => {
                this.setState({ showSuccessAlert: false })
            }, 4000)
        });
    }

    fnshowErrorAlert = () => {
        this.setState({ showErrorAlert: true }, () => {
            window.setTimeout(() => {
                this.setState({ showErrorAlert: false })
            }, 4000)
        });
    }


    ////////////// Patient Section ///////////////
    // Get Races
    getRaces = () => {
        let params = {
            "token": ''
        }
        commonpostApiFunction('getRace', params, this.getRaceResponse, this.onError);
    }
    getRaceResponse = (response) => {
        this.setState({ races: response.data.races })
    }

    races() {
        return (this.state.races.map(data => ({ label: data.RaceName, value: data.RaceDetailID })))
    }

    //Get Ethnicity
    getEthnicity = () => {
        let params = {
            //"action": "ethnicity"
            "token": ''
        }
        commonpostApiFunction('getEthnicity', params, this.getEthnicityResponse, this.onError);
    }
    getEthnicityResponse = (response) => {
        this.setState({ ethnicity: response.data.ethnicity })
    }
    ethnicity() {
        return (this.state.ethnicity.map(data => ({ label: data.EthnicityName, value: data.EthnicityDetailID })))
    }
    //Get SexualOrientation
    getSexualOrientation = () => {
        let params = {
            "token": ''
        }
        commonpostApiFunction('getSexualOrientation', params, this.getSexualOrientationResponse, this.onError);
    }
    getSexualOrientationResponse = (response) => {
        this.setState({ SexualOrientation: response.data.SexualOrientation })
    }
    sexualOrientation() {
        return (this.state.SexualOrientation.map(data => ({ label: data.SexualOrientationName, value: data.SexualOrientationDetailID })))
    }

    // Getting states 
    getStateList = () => {
        let params = {
            //"action":"getState"
            "token": ''
        }
        // console.log('statelist', params);
        commonpostApiFunction('getStateDetail', params, this.getStateResponse, this.onError);
    }

    getStateResponse = (response) => {
        this.setState({ stateData: response.data.StateList })
    }

    getState() {
        return (this.state.stateData.map((data, index) => ({ label: data.StateName, value: data.StateID, key: index })))
    }

    handleStateChange = async e => {
        if (e !== null) {
            await this.setState({
                valCity: [{ label: "Select...", value: 0 }],
                valState: [{ label: e.label, value: e.value }],
                patient_state: e.value,
                statename: e.label,
                patient_city: '',
            })
            let params = {
                "state_id": this.state.patient_state,
                "token": ''
            }
            commonpostApiFunction('getCityDetail', params, this.getCityResponse, this.onError);
        } else {
            await this.setState({
                valCity: [{ label: "Select...", value: 0 }],
                valState: [{ label: "Select...", value: 0 }],
                patient_state: '',
                statename: '',
                patient_city: '',
            })
        }

    }

    getCityResponse = (response) => {
        //console.log(response.data)
        this.setState({ cityData: response.data.CityList })
        //console.log("city", this.state.cityData);
    }

    getCity() {
        return (this.state.cityData.map((data, index) => ({ label: data.CityName, value: data.CityName, key: index })))
    }

    handleCityChange = async e => {
        if (e !== null) {
            await this.setState({
                valCity: [{ label: e.label, value: e.value }],
                patient_city: e.value
            })
        } else {
            await this.setState({
                valCity: [{ label: "Select..", value: 0 }],
                patient_city: ''
            })
        }
    }

    // Get country
    getCountry = () => {
        let params = {
            //"action": "getCountry"
            "token": ''
        }
        commongetApiFunction('getCountry', params, this.getCountryResponse, this.onError);
    }

    getCountryResponse = (response) => {
        this.setState({ countryData: response.data.countries })
    }

    CountryData() {
        return (this.state.countryData.map(data => ({ label: data.CountryName, value: data.CountryID })))
    }

    fetchCityChange(sid) {
        let params = {
            "state_id": this.state.patient_state,
            "token": ''
        }
        commonpostApiFunction('getCityDetail', params, this.fetchCityResponse, this.onError);
    }

    fetchCityResponse = (response) => {
        this.setState({ cityData: response.data.CityList })
    }

    fetchCity() {
        return (this.state.cityData.map((data, index) => ({ label: data.CityName, value: data.CityName, key: index })))
    }

    // For text fields
    handleAdd = async e => {
        const value = e.target.value;
        //console.log(value)
        await this.setState({
            ...this.state,
            [e.target.name]: value
        })
    }

    fetchAge = (dateselected) => {
        let params = {
            "user_dob": dateselected,
            "token": ''
        }
        commonpostApiFunction('calculateAge', params, this.fetchAgeResponse, this.onError);
    }

    fetchAgeResponse = (response) => {
        this.setState({ Age: response.data.dob[0].Age })
    }

    handleChange_Gender = async e => {
        await this.setState({
            valGender: [{ label: e.label, value: e.value, key: e.key }],
            patient_gender: e.key,
        })
    }

    handleChange_Races = async e => {
        if (e !== null) {
            await this.setState({
                valRace: [{ label: e.label, value: e.value }],
                patient_race: e.value,
            })
        } else {
            this.setState({
                patient_race: 0,
                valRace: [{ label: "Select..", value: 0 }]
            });
        }
    }

    handleChange_Ethnicity = async e => {
        if (e !== null) {
            await this.setState({
                valEthnicity: [{ label: e.label, value: e.value }],
                patient_ethnicity: e.value,
            })
        } else {
            this.setState({
                patient_ethnicity: 0,
                valEthnicity: [{ label: "Select..", value: 0 }]
            });
        }
    }

    handleChange_SexualOrientation = async e => {
        if (e !== null) {
            await this.setState({
                valSexualOrientation: [{ label: e.label, value: e.value }],
                patient_sexual_orientation: e.value,
            })
        } else {
            this.setState({
                patient_sexual_orientation: 0,
                valSexualOrientation: [{ label: "Select..", value: 0 }]
            });
        }
    }
    handleChange_country = async e => {
        await this.setState({
            valCountry: [{ label: e.label, value: e.value }],
            patient_country: e.label,
        })
    }

    // Function for change date 
    handleDateChange = (date) => {
        if (date == "Invalid Date" || date == null) {
            this.setState({
                patient_dob: date,
                selected_patient_dob: date,
            })
            this.validator.showMessageFor('Date of Birth')
            this.validator.showMessageFor('InvalidDOB')
        }
        else {
            let formattedDate = moment(date).format("MM-DD-YYYY")
            this.setState({
                patient_dob: formattedDate,
                selected_patient_dob: date,
            })
            this.fetchAge(formattedDate);
        }
    }

    handleInsuredDateChange = (date) => {
        if (date == "Invalid Date" || date == null) {
            this.setState({
                InsuredDOB: date,
                selected_InsuredDOB: date,
            })
            this.validator.showMessageFor('Insured Date of Birth')
            this.validator.showMessageFor('InsuredInvalidDOB')
        }
        else {
            let formattedDate = moment(date).format("MM-DD-YYYY")
            this.setState({
                InsuredDOB: formattedDate,
                selected_InsuredDOB: date,
            })

        }
    }

    ////////// End Patient Section //////////////


    ////////// Start Provider Section ////////////
    //get provider list 
    getProviderData = () => {
        //let {NPI, } = this.state;
        let params = {
            "UserID": this.state.userData.UserDetailID,
            "token": ''
        }
        commonpostApiFunction('getProviderList', params, this.getProviderResponse, this.onError);
    }

    getProviderResponse = (response) => {
        //console.log("Provider", response.data);
        if (response.data.success === '1') {
            this.setState({ ProviderData: response.data.getProviderList })
        } else {
        }
    }


    // Get Practice Data
    getPracticeName = async e => {
        if (e !== null) {
            await this.setState({
                ProviderDetailID: e.value,
                valProvider: [{ label: e.label, value: e.value }],
                ProviderSource: e.source,
                ProviderName: e.label,
                ProviderID: e.value,
            });

            let params = {
                "ProviderDetailID": this.state.ProviderDetailID,
                "ProviderSource": this.state.ProviderSource,
                "UserID": this.state.userData.UserDetailID,
                "token": ''
            }
            commonpostApiFunction('uspGetPracticeDetailForProvider', params, this.getPracticeDataResponse, this.onError);
        } else {
            await this.setState({
                ProviderDetailID: '',
                valProvider: [{ label: 'Select...', value: '' }],
                ProviderSource: '',
                valPractice: [{ label: 'Select...', value: '' }],
                Age: '',
                ProviderNPI: '',
                PracticePhoneNo: '',
                PracticeAddress: '',
                PracticeStateName: '',
                PracticeCityName: '',
                PracticeZipCode: '',
                PracticeFaxNo: '',
                PracticeNameID: '',
            });
            await this.setState({ PracticeData: [] })
        }
    }

    getPracticeDataResponse = async response => {
        if (response.data.success === '1') {
            await this.setState({
                valPractice: [{ label: 'Select...', value: '' }],
                ProviderNPI: '',
                PracticePhoneNo: '',
                PracticeAddress: '',
                PracticeStateName: '',
                PracticeCityName: '',
                PracticeZipCode: '',
                PracticeFaxNo: '',
                PracticeNameID: '',

            })

            await this.setState({ PracticeData: response.data.PracticeDataList })
            if (response.data.PracticeDataList.length == 1) {

                //console.log(response.data.PracticeDataList[0].PracticeCityName)
                await this.setState({
                    PracticeName: response.data.PracticeDataList[0].PracticeName,
                    ProviderNPI: response.data.PracticeDataList[0].ProviderNPI,
                    PracticePhoneNo: response.data.PracticeDataList[0].PracticePhoneNo,
                    PracticeAddress: response.data.PracticeDataList[0].PracticeAddress,
                    PracticeStateName: response.data.PracticeDataList[0].PracticeStateName,
                    PracticeCityName: response.data.PracticeDataList[0].PracticeCityName,
                    PracticeZipCode: response.data.PracticeDataList[0].PracticeZipCode,
                    PracticeFaxNo: response.data.PracticeDataList[0].PracticeFaxNo,
                    PracticeNameID: response.data.PracticeDataList[0].PracticeNameID,
                    valPractice: [{ label: response.data.PracticeDataList[0].CompletePracticeName, value: response.data.PracticeDataList[0].PracticeNameID }],
                })
            }
        }
    }


    changePracticeName = async e => {
        //console.log(e);
        if (e !== null) {
            let item = this.state.PracticeData[e.key]
            await this.setState({
                ProviderNPI: item.ProviderNPI,
                PracticePhoneNo: item.PracticePhoneNo,
                PracticeAddress: item.PracticeAddress,
                PracticeStateName: item.PracticeStateName,
                PracticeCityName: item.PracticeCityName,
                PracticeZipCode: item.PracticeZipCode,
                PracticeFaxNo: item.PracticeFaxNo,
                PracticeNameID: item.PracticeNameID,
                valPractice: [{ label: e.label, value: e.value }],
            })
        } else {
            this.setState({
                ProviderNPI: '',
                PracticePhoneNo: '',
                PracticeAddress: '',
                PracticeStateName: '',
                PracticeCityName: '',
                PracticeZipCode: '',
                PracticeFaxNo: '',
                PracticeNameID: '',
                valPractice: [{ label: 'Select...', value: '' }],
            })
        }

    }

    Providers() {
        return (this.state.ProviderData.map((data, index) => ({ label: data.ProviderName, value: data.ProviderDetailID, key: index, source: data.Source })))
    }

    practiceOptions() {
        return (this.state.PracticeData.map((data, index) => ({ label: data.CompletePracticeName, value: data.PracticeNameID, key: index })))
    }

    //////////// End Provider Section ///////////


    //////////// Insurance Section ///////////////////

    handleChange_InsuredRelationship = async e => {
        if (e !== null) {
            if (e.label == "Self") {
                let InsuredPersonFirstName = this.state.PatientFirstName !== undefined ? this.state.PatientFirstName : '';
                let InsuredPersonMiddleName = this.state.PatientMiddleName !== undefined ? " " + this.state.PatientMiddleName + " " : '';
                let InsuredPersonLastName = this.state.PatientLastName !== undefined ? this.state.PatientLastName : '';

                await this.setState({
                    iInsuredName: InsuredPersonFirstName + InsuredPersonMiddleName + InsuredPersonLastName,
                    valInsuredRelationship: [{ label: e.label, value: e.value }],
                    InsuredRelationshipID: e.value,
                    // selected_InsuredDOB: this.state.selected_patient_dob,
                    // InsuredDOB: moment(this.state.selected_patient_dob).format("MM-DD-YYYY"),
                    // iGroup:'1',
                    // iId:'1',
                })
            } else {
                await this.setState({
                    //iInsuredName:'',
                    valInsuredRelationship: [{ label: e.label, value: e.value }],
                    InsuredRelationshipID: e.value,
                    // selected_InsuredDOB: '',
                    // InsuredDOB: '',
                    // iGroup:'',
                    // iId:'',
                })
            }
        } else {
            await this.setState({
                // iInsuredName:'',
                valInsuredRelationship: [{ label: 'Select...', value: '' }],
                InsuredRelationshipID: 0,
            })
        }
    }

    //get subscriber relation ship detail

    uspGetRelationshipDetail = () => {
        let params = {
            "token": ''
        }
        commonpostApiFunction('uspGetRelationshipDetail', params, this.uspGetRelationshipDetailResponse, this.onError);
    }

    uspGetRelationshipDetailResponse = (response) => {
        //console.log(response);
        if (response.data.success == '1') {
            this.setState({ RelationshipData: response.data.RelationshipDetailList })

        } else {

        }

    }
    //ends here

    RelationshipDetailOption() {
        return (this.state.RelationshipData.map((data, index) => ({ label: data.RelationshipName, value: data.RelationshipDetailID, key: index })))
    }


    onFileChange = async (e) => {
        let randomString = Math.random().toString(36);
        console.log('checkdoc', this.state.InsuranceDocument);
        if (this.state.InsuranceDocument.length < 3) {
            console.log(e.target.value);
            if (e.target.files.length > 0) {



                var i = 0;

                if (e.target.files[i].type == 'image/png' || e.target.files[i].type == 'image/jpg' || e.target.files[i].type == 'image/jpeg' || e.target.files[i].type == 'application/pdf') {

                    this.setState({ InsuranceDocument: ([...this.state.InsuranceDocument, e.target.files[0]]) });

                } else {
                    this.setState({ fileTypeErr: true, errorMsg: 'Upload valid Files. Only PNG, JPG, JPEG, PDF are allowed.' })

                    this.uploadValidator.showMessages();
                    this.fnshowErrorAlert();
                    this.setState({

                        fileInputKey: randomString,
                    })
                    window.scrollTo(0, 0);

                }

                console.log("Doc", this.state.InsuranceDocument);
            } else {
                // this.setState({InsuranceDocument:''});
                this.setState({ InsuranceDocument: ([...this.state.InsuranceDocument]) });
            }



        } else {
            this.setState({ InsuranceDocument: ([...this.state.InsuranceDocument]), fileTypeErr: true, errorMsg: 'Only 3 files are allowed to upload.' })

            this.uploadValidator.showMessages();
            this.fnshowErrorAlert();

            this.setState({

                fileInputKey: randomString,
            })
        }
    };


    getInsuranceList = () => {
        let params = {
            "token": ''
        }
        commonpostApiFunction('getInsuranceDetail', params, this.getInsuranceDetailResponse, this.onError);
    }

    getInsuranceDetailResponse = (response) => {
        //console.log(response);
        if (response.data.success == '1') {
            this.setState({
                InsuranceCompanyData: response.data.InsuranceList,

            })
        } else {
            this.setState({

            })
        }

    }

    InsuranceCompanyList() {
        return (this.state.InsuranceCompanyData.map((data, index) => ({ label: data.CompleteName, value: data.InsuranceManagerDetailID, InsuranceCode: data.InsuranceCode, key: index })))
    }

    handleChangeCompany = selectedOption => {
        if (selectedOption !== null) {
            // console.log(selectedOption.label.split("-"));
            var InsurancePieces = selectedOption.label.split("-");
            // console.log("a", InsurancePieces[0]);
            this.setState({
                InsuranceCompanyID: selectedOption.value,
                valInsuranceCompany: selectedOption,
                iPlanCode: InsurancePieces[0],
                iCompany: InsurancePieces[1],
                iAddress: InsurancePieces[2]
            });
        } else {
            this.setState({
                InsuranceCompanyID: '',
                valInsuranceCompany: '',
                iPlanCode: '',
                iCompany: '',
                iAddress: ''
            });
        }
        // console.log("O",JSON.stringify(this.state.valInsuranceCompany.toString().split("-")));
    };


    //////////////////// End Insurance Section //////////////////

    //////////////////// Diagnosis Section /////////////////////


    uspGetTestResult = () => {
        let params = {
            "token": ''
        }
        commonpostApiFunction('getTestResult', params, this.getTestDetailResponse, this.onError);
    }

    getTestDetailResponse = (response) => {

        if (response.data.success == '1') {
            this.setState({ TestData: response.data.GetTestResultData })

        } else {

        }

    }

    testDataOption() {
        return (this.state.TestData.map((data, index) => ({ label: data.TestName, value: data.TestID, key: index })))
    }

    handleChangeTest = selectedOption => {
        this.setState(
            { valLabTest: selectedOption }
        );
    };

    ///// View Tests

    uspViewTestResult = (e) => {
        let params = {
            "OrderId": e,
            "token": ''
        }
        commonpostApiFunction('viewTestResult', params, this.viewTestDetailResponse, this.onError);
    }

    viewTestDetailResponse = (response) => {
        if (response.data.success == '1') {
            this.setState({ STestData: response.data.ViewTestResultData })
            this.getDefaultTest(this.state.STestData);
        } else {

        }
    }

    ResetFields = () => {
        let randomString = Math.random().toString(36);
        this.setState({
            showLink: 0,
            selected_patient_dob: '',
            //patient_dob:'',
            selected_InsuredDOB: '',
            valEthnicity: [{ label: "Select..", value: 0 }],
            valRace: [{ label: "Select..", value: 0 }],
            valSexualOrientation: [{ label: "Select...", value: 0 }],
            valGender: [{ label: "Select..", value: 0 }],
            patient_gender_id: '',
            InsuranceDocument: [],
            valLabTest: '',
            InsuredRelationshipID: '',
            InsuredDOB: '',
            iInsuredName: '',
            iGroup: '',
            iId: '',
            iAddress: '',
            iCompany: '',
            iPlanCode: '',
            InsuranceCompanyID: '',

            patient_requisition_number: '',
            patient_home_phone: '',
            patient_cell_phone: '',
            patient_zipcode: '',
            patient_case_address_line_2: '',
            patient_case_address_line_1: '',
            patient_country: '',
            patient_ssn: '',
            patient_ethnicity: '',
            patient_race: '',
            patient_sexual_orientation: '',
            patient_gender: '',
            PatientLastName: '',
            PatientMiddleName: '',
            PatientFirstName: '',

            valCity: [{ label: "Select...", value: '' }],
            valState: [{ label: "Select...", value: '' }],
            patient_state: '',
            statename: '',
            patient_city: '',
            cityData: [],
            valInsuranceCompany: [{ label: 'Select...', value: '' }],
            Age: '',
            valInsuredRelationship: [{ label: 'Select...', value: '' }],
            fileInputKey: randomString,
            ap_test_time: '',
            ap_test_day: '',
            selected_ap_test_day:'',
            PatientEmailID: '',
            InsuranceDocument: '',
            cash_payment: '',
            valTestTime: [{ label: "Select...", value: 0 }],
        })
        // this.ClearSearch();

    }
    //onFileChange =async (e)=>{
    handleInputFileChange = (event) => {
        this.setState({
            InsuranceDocument: event.target.files,

        });
    }
    /////////////////// End Diagnosis /////////////////////////

    ///////////////////// Utility Section ////////////////////
    // Add new Records 
    handle_saveAppointment = (e) => {
        e.preventDefault();
        //this.verifyLoginObject();

        this.validator.hideMessages();
        if (this.validator.allValid()) {
            this.setState({ isButtonDisabled: true })
            FreezeUI({ text: "Loading...", selector: 'body' });
            let fd = new FormData();
            let token = '';

            for (let i = 0; i < this.state.InsuranceDocument.length; i++) {
                fd.append("InsuranceDocument[]", this.state.InsuranceDocument[i]);
            }
            // fd.append("CreatedBy", this.state.userData.UserDetailID);
            fd.append("Test_Testnames", JSON.stringify(this.state.valLabTest));
            //fd.append('InsuranceDocument', this.state.InsuranceDocument);
            fd.append("Insurance_uploadedDocument", this.state.UploadedInsuranceDocument);
            fd.append("Insurance_InsuredRelation", this.state.InsuredRelationshipID);
            fd.append("Insurance_InsuredDOB", this.state.InsuredDOB);
            fd.append("Insurance_InsuredName", this.state.iInsuredName);
            fd.append("Insurance_Group", this.state.iGroup);
            fd.append("Insurance_ID", this.state.iId);
            fd.append("Insurance_CompanyAddress", this.state.iAddress);
            fd.append("Insurance_CompanyName", this.state.iCompany);
            fd.append("Insurance_PlanCode", this.state.iPlanCode);
            fd.append("Insurance_CompanyID", this.state.InsuranceCompanyID);

            fd.append("Patient_RequisitionNumber", this.state.patient_requisition_number);
            fd.append("Patient_HomePhone", this.state.patient_home_phone);
            fd.append("Patient_Phone", this.state.patient_cell_phone);
            fd.append("Patient_Zip", this.state.patient_zipcode);
            fd.append("Patient_Address2", this.state.patient_case_address_line_2);
            fd.append("Patient_Address1", this.state.patient_case_address_line_1);
            fd.append("Patient_City", this.state.patient_city);
            fd.append("Patient_State", this.state.statename);
            fd.append("Patient_Country", this.state.patient_country);
            fd.append("Patient_SSN", this.state.patient_ssn);
            fd.append("Patient_Ethnicity", this.state.patient_ethnicity === null || this.state.patient_ethnicity.trim() === "" ? "" : this.state.patient_ethnicity);
            fd.append("Patient_Race", this.state.patient_race === null || this.state.patient_race.trim() === "" ? "" : this.state.patient_race);
            fd.append("Patient_Sexual_Orientation", this.state.patient_sexual_orientation);
            fd.append("Patient_Gender", this.state.patient_gender);
            fd.append("Patient_DOB", this.state.patient_dob);
            fd.append("Patient_LastName", this.state.PatientLastName);
            fd.append("Patient_MiddleName", this.state.PatientMiddleName);
            fd.append("PatientEmailID", this.state.PatientEmailID);
            fd.append("Patient_FirstName", this.state.PatientFirstName);

            fd.append("cash_payment", this.state.cash_payment);
            fd.append("ap_test_time", this.state.ap_test_time);
            fd.append("ap_test_day", this.state.ap_test_day);


            uploadImageFileFunctionRest('/saveAppointment', fd, this.saveAppointmentResponse, token);

        } else {
            this.validator.showMessages();
            this.errorFocus(this.validator.fields);
        }
    }

    saveAppointmentResponse = (response) => {
        //console.log('new patient response',response.data)
        //this.handleAlert("successAlert", true);
        UnfreezeUI();
        if (response.data.success == "1") {

            this.setState({
                AppointmentPlaceResponse: response.data.AddAppointmentResponse[0].Comment, sweetAlertTitle: "Success", message: ''
            })
            this.handleAlert("successAlert", true);
            this.ResetFields();
            this.setState({ isButtonDisabled: false })
        }
        else {

            this.setState({
                AppointmentPlaceResponse: response.data.AddAppointmentResponse[0].Comment, sweetAlertTitle: "Error"
            })
            this.handleAlert("errorAlert", true)
            this.setState({ isButtonDisabled: false })
        }
    }
    errorFocus = (validatordata) => {
        let result = Object.keys(validatordata)
            .map(key => ({ name: key, val: validatordata[key] }));

        console.log(result);
        inputids.every((item, index) => {
            var value = item.value;
            console.log(validatordata[value]);
            var id = item.id;
            if (validatordata[value] == false) {
                console.log(id);
                document.getElementById(id).focus();
                return false;
            }
            return true;
        });
    }
    handleAlert = (state, value) => {
        //console.log(state,value)
        this.setState({ [state]: value })
    }

    onError(error) {
        console.log(error);
    }
    ///////////////////// End Utility Section ////////////////

    handleTestingTimeold = (selectedDates, dateStr, instance) => {
        this.setState({ ap_test_time: dateStr })
    }

    // handleCashPayment = () => {
    // this.setState({ rg_test_time: dateStr })
    // }
    handleCashPayment = async location => {
        console.log("location", location.target.checked);
        await this.setState({

            //CaseNo: location.target.checked===false ? '':'',
            cash_payment: location.target.checked === true ? 1 : 0
        });

    }
    //-------------------------------------------

    getTimes = async(from,to) => {
     
        // console.log("from", from);
        // console.log("to", to);
        let increment = 6;

        let fromarr=from.split(":");
        let start_hr=(fromarr[1].split(" ")[1]=='PM' && Number(fromarr[0])!=12)?(Number(fromarr[0])+12):Number(fromarr[0]);
        let start_min=Number(fromarr[1].split(" ")[0]);

        let toarr=to.split(":");
        let end_hr=(toarr[1].split(" ")[1]=='PM' && Number(toarr[0])!=12)?(Number(toarr[0])+12):Number(toarr[0]);
        let end_min=Number(toarr[1].split(" ")[0]);
        // console.log("start_hr", start_hr);
        // console.log("start_min", start_min);
        // console.log("end_hr", end_hr);
        const times = [];
        for (let i = start_hr; i <= Number(end_hr); i++) {
            // console.log("i", i);
            // console.log("start_min q", start_min);
            if(i == start_hr && start_min=='30'){
                times.push({
                    value: `${from}`,
                    label: `${from}`,
                });  
                for (let j = 40; j < 60; j += 60 / increment) {
                    times.push({
                        value: `${i === 0 || i - 12 === 0 ? 12 : i < 12 ? i : i - 12}:${Math.ceil(j)} ${i < 12 ? 'AM' : 'PM'}`,
                        label: `${i === 0 || i - 12 === 0 ? 12 : i < 12 ? i : i - 12}:${Math.ceil(j)} ${i < 12 ? 'AM' : 'PM'}`,
                    });
                }
            }else if(i == end_hr && end_min=='30'){
                times.push({
                    value: `${i === 0 || i - 12 === 0 ? 12 : i < 12 ? i : i - 12}:00 ${i < 12 ? 'AM' : 'PM'}`,
                    label: `${i === 0 || i - 12 === 0 ? 12 : i < 12 ? i : i - 12}:00 ${i < 12 ? 'AM' : 'PM'}`,
                });
                for (let j = 10; j < 30; j += 60 / increment) {
                    times.push({
                        value: `${i === 0 || i - 12 === 0 ? 12 : i < 12 ? i : i - 12}:${Math.ceil(j)} ${i < 12 ? 'AM' : 'PM'}`,
                        label: `${i === 0 || i - 12 === 0 ? 12 : i < 12 ? i : i - 12}:${Math.ceil(j)} ${i < 12 ? 'AM' : 'PM'}`,
                    });
                }
            }else if(i < end_hr){
               // console.log("i", i);
                times.push({
                value: `${i === 0 || i - 12 === 0 ? 12 : i < 12 ? i : i - 12}:00 ${i < 12 ? 'AM' : 'PM'}`,
                label: `${i === 0 || i - 12 === 0 ? 12 : i < 12 ? i : i - 12}:00 ${i < 12 ? 'AM' : 'PM'}`,
            });
       
            for (let j = 60 / increment; j < 60; j += 60 / increment) {
                times.push({
                    value: `${i === 0 || i - 12 === 0 ? 12 : i < 12 ? i : i - 12}:${Math.ceil(j)} ${i < 12 ? 'AM' : 'PM'}`,
                    label: `${i === 0 || i - 12 === 0 ? 12 : i < 12 ? i : i - 12}:${Math.ceil(j)} ${i < 12 ? 'AM' : 'PM'}`,
                });
            }
        }
        }
        times.push({
            value: `${to}`,
            label: `${to}`,
        });

        await this.setState({
            TimeData: times,
        })
        //   console.log(this.state.TimeData);
    }
    
    // TestTimeOptions() {
    //     return (this.state.TimeData.map(data => ({ label: data.label, value: data.value })))
    // }

    handleTestingTime = async e => {
        if (e !== null) {
            await this.setState({

                valTestTime: [{ label: e.label, value: e.value }],
                ap_test_time: e.value,

            })

        } else {
            await this.setState({
                valTestTime: [{ label: "Select...", value: 0 }],
                ap_test_time: '',

            })
        }

    }
    deleteFile(e) {
        const s = this.state.InsuranceDocument.filter((item, index) => index !== e);
        this.setState({ InsuranceDocument: s });

        document.getElementById("fileupload").value = null;
    }
    handleAPDateChange = (date) => {
        if (date == "Invalid Date" || date == null || date.getDay() === 0 || date.getDay() === 6) {
            this.setState({
                ap_test_day: date,
                selected_ap_test_day: date,
            })
            this.validator.showMessageFor('Date of Birth')
            this.validator.showMessageFor('InvalidWeekend')
        }
        else {
            let formattedDate = moment(date).format("MM-DD-YYYY")
            this.setState({
                ap_test_day: formattedDate,
                selected_ap_test_day: date,
                valTestTime: [{ label: "Select...", value: 0 }],
                ap_test_time: '',
            })
            //this.fetchAge(formattedDate);
            // let timefiletr= TimingSlot.filter(item => item.DayValue === date.getDay());

            // this.getTimes(timefiletr[0].From,timefiletr[0].To);

            let formattedDateYMD = moment(date).format("YYYY-MM-DD");

            this.GetAppointmentTimeSlot(formattedDateYMD);
        }
    }

    GetAppointmentTimeSlot = (InputDate) => {
        let params = {
            "InputDate": InputDate,
            "token": ''
        }
        commonpostApiFunction('uspGetAppointmentTimeSlot', params, this.GetAppointmentTimeSlotResponse, this.onError);
    }

    GetAppointmentTimeSlotResponse = (response) => {
        //console.log(response);
        if (response.data.success == '1') {
            this.setState({ TimeSlotData: response.data.TimeSlotList })

        } else {

        }

    }
   

    TestTimeOptions() {
        return (this.state.TimeSlotData.map(data => ({ label: data.IntervalTime, value: data.IntervalTime })))
    }

    render() {

        const { selected } = this.state;
        this.validator.purgeFields();

        return (
            <div>
                <Helmet>
                    <title>Genesis Appointment System</title>
                </Helmet>
                <HeaderRegistration logoName={'layout4/logo_gensys.png'} />
                <Card className="mt-2 ml-4 mr-4">

                    <CardBody >
                        <SweetAlert success title={this.state.sweetAlertTitle}
                            show={this.state.successAlert}
                            onConfirm={() => this.handleAlert("successAlert", false)}>
                            <p className="sweet-alert-text text-center"> {this.state.AppointmentPlaceResponse}</p>
                        </SweetAlert>
                        <SweetAlert error title={this.state.sweetAlertTitle}
                            show={this.state.errorAlert}
                            onConfirm={() => this.handleAlert("errorAlert", false)}
                        >
                            <p className="sweet-alert-text text-center">
                                {this.state.AppointmentPlaceResponse}
                            </p>
                        </SweetAlert>
                        <FormGroup>
                            {
                                this.state.showSuccessAlert ?
                                    <div>
                                        <Alert color="success" isOpen={this.state.showSuccessAlert}><CheckCircle />{this.state.successMsg}</Alert>
                                    </div> : null
                            }
                            {
                                this.state.showErrorAlert ?
                                    <div>
                                        <Alert color="danger" isOpen={this.state.showErrorAlert}><AlertTriangle />{this.state.errorMsg}</Alert>
                                    </div> : null
                            }
                        </FormGroup>
                        <Row>
                            <Col md="12" className="mb-3">
                                <span className="text-danger">
                                    <i>
                                        Note- “Please note that a prescription/requisition from a physician is mandatory for any type of testing at our laboratory, including COVID-19.”
                                    </i>{" "}
                                </span>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={12}>
                               
                                <FormGroup>
                                    <h4 className='title_bg'>Test Details</h4>
                                </FormGroup>
                                <hr />
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col md={6}>
                                <Label for="DiagnosisTest">Choose Test <font size="3" color="red">*</font>&nbsp; </Label>
                                <Select
                                    className="React"
                                    classNamePrefix="select"
                                    isMulti
                                    isClearable={true}
                                    value={this.state.valLabTest}
                                    options={this.testDataOption()}
                                    name="test"
                                    onChange={this.handleChangeTest}
                                />
                                {this.validator.message('Test Name', this.state.valLabTest, 'required')}

                            </Col>
                            <Col md={3}>
                                <label htmlFor="ap_test_day">Date for test <font size="3" color="red">*</font> </label>
                                <LSDatePicker2
                                    className="form-control white"
                                    //disableFuture
                                    shouldDisableDate={function (date) {
                                                            
                                        return (date.getDay() === 0 || date.getDay() === 6);

                                    }}
                                    id="LSDatePicker_3"
                                    autoOk={true}
                                    views={["year", "month", "date"]}
                                    format="MM-dd-yyyy"
                                    placeholder="MM-DD-YYYY"
                                    variant="inline"
                                    minDate={new Date()}
                                    value={this.state.selected_ap_test_day ? this.state.selected_ap_test_day : null}
                                    onChange={this.handleAPDateChange}
                                    KeyboardButtonProps={{ "aria-label": "change date" }}
                                    InputProps={{ disableUnderline: true }}
                                />

                                {/*<Flatpickr
                                    className={"form-control"}
                                    name="ap_test_day"
                                    options={{
                                        minDate: "today", dateFormat: "m-d-Y", "disable": [
                                            function (date) {

                                                return (date.getDay() === 0 || date.getDay() === 6);

                                            }
                                        ]
                                    }}
                                    value={this.state.ap_test_day}
                                    onChange={(selectedDates, dateStr, instance) => this.setState({ ap_test_day: dateStr })}
                                //onChange={e => this.setState({ ap_test_day: e.target.value })}
                                />
                                */}
                         {this.validator.message('date for test', this.state.ap_test_day, 'required|InvalidWeekend')}
                            </Col>

                            {/*  <Col md={3}>
                                            <label htmlFor="ap_test_time">Time for test <font size="3" color="red">*</font>  </label>
                                            <Flatpickr
                                                className={"form-control"}
                                                name="ap_test_time"
                                                options={{
                                                    enableTime: true,
                                                    noCalendar: true,
                                                    dateFormat: "h:i K",
                                                    time_24hr: false,
                                                    minuteIncrement: 10,
                                                    // defaultDate: "09:15",
                                                    minTime: "10:00",
                                                    maxTime: "17:00",
                                                    
													defaultHour:(new Date().getHours())+1,

                                                    defaultMinute:new Date().getMinutes(),
                                                    clickOpens: true

                                                }}
                                                value={this.state.ap_test_time}
                                                onChange={this.handleTestingTime}
                                            />
                                            {this.validator.message('time for test', this.state.ap_test_time, 'required')}
                                         </Col>
	*/}
                            <Col md={3}>
                                <label htmlFor="ap_test_time">Time for test <font size="3" color="red">*</font>  </label>
                                <Select
                                    name="ap_test_time"
                                    options={this.TestTimeOptions()}
                                    value={this.state.valTestTime}
                                    onChange={this.handleTestingTime}
                                />

                                {this.validator.message('time for test', this.state.ap_test_time, 'required')}
                            </Col>

                        </Row>

                        <Row>
                            <Col md={12}>
                            <hr />
                                <h4 className='title_bg'>Patient Detail</h4>
                                <hr />
                            </Col>
                        </Row>
                        {/* Patient Info Line 1 Start Here */}

                        <Row className="mb-3">
                            <Col md={2}>
                                <Label for="PatientFirstName">First Name <font size="3" color="red">*</font>&nbsp;</Label>
                                <Input type="text"
                                    name="PatientFirstName"
                                    id="PatientFirstName"
                                    placeholder="Patient First Name"
                                    onChange={e => this.setState({ PatientFirstName: e.target.value })}
                                    value={this.state.PatientFirstName}
                                    className="form-control"
                                />
                                {this.validator.message('FirstName', this.state.PatientFirstName, 'required', { messages: { PatientFirstName: 'First Name is Required.' } })}
                            </Col>
                            <Col md={2}>
                                <Label for="PatientMiddleName">Middle Name </Label>
                                <Input type="text"
                                    name="PatientMiddleName"
                                    placeholder="Patient Middle Name"
                                    onChange={e => this.setState({ PatientMiddleName: e.target.value })}
                                    value={this.state.PatientMiddleName}
                                    className="form-control"
                                />
                            </Col>
                            <Col md={2}>
                                <Label for="PatientLastName">Last Name <font size="3" color="red">*</font>&nbsp;</Label>
                                <Input type="text"
                                    name="PatientLastName"
                                    id="PatientLastName"
                                    placeholder="Patient Last Name"
                                    onChange={e => this.setState({ PatientLastName: e.target.value })}
                                    value={this.state.PatientLastName}
                                    className="form-control"
                                />
                                {this.validator.message('LastName', this.state.PatientLastName, 'required', { messages: { PatientLastName: 'Last Name is Required.' } })}
                            </Col>

                            <Col md={2}>
                                <Label for="PatientGender">Gender <font size="3" color="red">*</font>&nbsp;</Label>
                                <Select
                                    value={this.state.valGender}
                                    onChange={this.handleChange_Gender}
                                    name="patient_gender"
                                    id="patient_gender"
                                    options={this.genderOptions()}
                                />
                                {this.validator.message('Gender', this.state.patient_gender, 'required')}
                            </Col>
                            <Col md={2}>
                                <Label for="PatientDOB">DOB <font size="3" color="red">*</font>&nbsp;</Label>
                                <LSDatePicker
                                    className="form-control white"
                                    disableFuture
                                    id="LSDatePicker_1"
                                    autoOk={true}
                                    views={["year", "month", "date"]}
                                    format="MM-dd-yyyy"
                                    placeholder="MM-DD-YYYY"
                                    variant="inline"
                                    maxDate={new Date()}
                                    value={this.state.selected_patient_dob ? this.state.selected_patient_dob : null}
                                    onChange={this.handleDateChange}
                                    KeyboardButtonProps={{ "aria-label": "change date" }}
                                    InputProps={{ disableUnderline: true }}
                                />
                                {this.validator.message('Date of Birth', this.state.patient_dob, 'required|InvalidDOB', { messages: { InvalidDOB: 'The date of birth is invalid.' } })}

                            </Col>
                            <Col md={2}>
                                <Label for="PatientAge">Age</Label>
                                <Input type="text" name="patient_age" id="patient_age" placeholder="Age" onChange={this.handleDOBChanged} value={this.state.Age} readOnly />

                            </Col>
                        </Row>
                        {/* Patient Info Line 1 Ends Here */}

                        {/* Patient Info Line 2 Start Here */}

                        <Row className="mb-3">
                            <Col md={2}>
                                <Label for="PatientRace">Race <font size="3" color="red">*</font>&nbsp;</Label>
                                <Select name="patient_race" className="React" classNamePrefix="select" isClearable={true} options={this.races()} value={this.state.valRace} onChange={this.handleChange_Races} />
                                {this.validator.message('Race', this.state.patient_race, 'required')}
                            </Col>
                            <Col md={2}>
                                <Label for="PatientEthnicity">Ethnicity <font size="3" color="red">*</font>&nbsp;</Label>
                                <Select name="patient_ethnicity" className="React" classNamePrefix="select" isClearable={true} options={this.ethnicity()} value={this.state.valEthnicity} onChange={this.handleChange_Ethnicity} />
                                {this.validator.message('Ethnicity', this.state.patient_ethnicity, 'required')}
                            </Col>
                            <Col md={2}>
                                <Label for="patient_sexual_orientation">Sexual Orientation <font size="3" color="red">*</font>&nbsp;</Label>
                                <Select name="patient_sexual_orientation" className="React" classNamePrefix="select" isClearable={true} styles={false} options={this.sexualOrientation()} value={this.state.valSexualOrientation} onChange={this.handleChange_SexualOrientation} />
                                {this.validator.message('Sexual Orientation', this.state.patient_sexual_orientation, 'required')}
                            </Col>
                            <Col md={2}>
                                <Label for="PatientPhone">Home Phone</Label>
                                <InputMask
                                    type="text"
                                    name="patient_home_phone"
                                    id="patient_home_phone"
                                    onChange={this.handleAdd}
                                    value={this.state.patient_home_phone}
                                    placeholder="Home Phone"
                                    mask="1-999-999-9999"
                                    className="form-control"
                                />
                                {this.validator.message('Home Phone', this.state.patient_home_phone, 'InvalidPhone', { messages: { InvalidPhone: 'The home phone number is invalid.' } })}
                            </Col>
                            <Col md={2}>
                                <Label for="PatientCell">Cell Phone <font size="3" color="red">*</font>&nbsp;</Label>
                                <InputMask
                                    name="patient_cell_phone"
                                    id="patient_cell_phone"
                                    onChange={this.handleAdd}
                                    value={this.state.patient_cell_phone}
                                    placeholder="Cell Phone"
                                    className="form-control" mask="+1-999-999-9999"
                                />
                                {this.validator.message('Cell Phone', this.state.patient_cell_phone, 'required|InvalidPhone', { messages: { InvalidPhone: 'The cell phone number is invalid.' } })}
                            </Col>
                            <Col md={2}>
                                <Label for="PatientEmailID">Email ID <font size="3" color="red">*</font>&nbsp;</Label>
                                <Input type="text"
                                    name="PatientEmailID"
                                    id="PatientEmailID"
                                    placeholder="Patient Email ID"
                                    onChange={e => this.setState({ PatientEmailID: e.target.value })}
                                    value={this.state.PatientEmailID}
                                    className="form-control"
                                />
                                {this.validator.message('EmailID', this.state.PatientEmailID, 'required|email', { messages: { PatientEmailID: 'Email ID is Required.' } })}
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col md={2}>
                                <Label for="PatientRequisitionNumber">Requisition Number</Label>
                                <input type="text" name="patient_requisition_number" id="patient_requisition_number" onChange={this.handleAdd} value={this.state.patient_requisition_number} placeholder="Requisition Number" className="form-control" />
                            </Col>
                            <Col md={2}>
                                <Label for="PatientSSN">SSN</Label>
                                <InputMask
                                    name="patient_ssn"
                                    id="patient_ssn"
                                    onChange={this.handleAdd}
                                    placeholder="SSN"
                                    value={this.state.patient_ssn}
                                    mask="999-99-9999" className="form-control"
                                />
                                {this.validator.message('Ssn', this.state.patient_ssn, 'InvalidPhone', { messages: { InvalidPhone: 'The SSN number is invalid.' } })}
                            </Col>
                            <Col md={2}>
                                <Label for="PatientAddress1">Address Line 1 <font size="3" color="red">*</font>&nbsp;</Label>
                                <input type="text" name="patient_case_address_line_1" id="patient_case_address_line_1" onChange={this.handleAdd} value={this.state.patient_case_address_line_1} placeholder="Address Line 1" className="form-control" />
                                {this.validator.message('Address1', this.state.patient_case_address_line_1, 'required|max:100')}
                            </Col>
                            <Col md={2}>
                                <Label for="PatientAddress2">Address Line 2</Label>
                                <Input type="text" name="patient_case_address_line_2" id="patient_case_address_line_2" onChange={this.handleAdd} value={this.state.patient_case_address_line_2} placeholder="Address Line 2" />
                                {this.validator.message('Address2', this.state.patient_case_address_line_2, 'max:100')}
                            </Col>
                            <Col md={2}>
                                <Label for="PatientState">State <font size="3" color="red">*</font>&nbsp;</Label>
                                <Select
                                    name="patient_state"
                                    options={this.getState()}
                                    className="react-select-value"
                                    isSearchable
                                    isClearable={true}
                                    styles={false}
                                    value={this.state.valState}
                                    onChange={this.handleStateChange}
                                />
                                {this.validator.message('State', this.state.patient_state, 'required')}
                            </Col>
                            <Col md={2}>
                                <Label for="PatientCity">City <font size="3" color="red">*</font>&nbsp;</Label>
                                <CreatableSelect
                                    name="patient_city"
                                    isClearable={true}
                                    styles={false}
                                    options={this.getCity()}
                                    className="React"
                                    classNamePrefix="select"
                                    value={this.state.valCity}
                                    onChange={this.handleCityChange}
                                />
                                {this.validator.message('City', this.state.patient_city, 'required')}
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col md={2}>
                                <Label for="PatientZipCode">Zip Code <font size="3" color="red">*</font>&nbsp;</Label>
                                <input type="text" name="patient_zipcode" id="patient_zipcode" placeholder="Zip Code" onChange={this.handleAdd} value={this.state.patient_zipcode}
                                    className="form-control" maxLength="5" />
                                {this.validator.message('zip', this.state.patient_zipcode, 'required|max:5')}
                            </Col>
                            <Col md={2}>
                                <Label for="PatientCountry">Country </Label>
                                <Select name="patient_country" defaultValue={country[0]} options={this.CountryData()} onChange={this.handleChange_country} isDisabled={true} />
                            </Col>
                        </Row>
                        {/* Patient Info Line 2 Ends Here */}

                        {/* Patient Info Line 3 Start Here 
                    <Row>
                        <Col md={2}>
                            <Label for="PatientCountry">Country </Label>
                            <Select name="patient_country" defaultValue={country[0]} options={this.CountryData()} onChange={this.handleChange_country} isDisabled={true} />
                        </Col>
                    </Row>*/}
                        {/* Patient Info Line 3 Ends Here */}


                        <Row>

                            <Col md={12}>
                                <hr />
                                <FormGroup>

                                    <h4 className='title_bg'>Insurance Detail</h4>

                                </FormGroup>
                                <hr />
                            </Col>

                        </Row>
                        {/* Patient Insurance Info Line 1 Start Here */}

                        <Row className="mb-3">
                            <Col md={12}>
                                <p>&nbsp;</p>
                                <label className="checkbox-design">Cash Payment
                                    <input type="checkbox" name="cash_payment"
                                        value={this.state.cash_payment}
                                        onClick={this.handleCashPayment}
                                        checked={this.state.cash_payment == 1 ? "checked" : ''}
                                    />
                                    <span className="checkmark" ></span></label>

                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col md={4}>
                                <Label for="InsuranceCompany">Choose Insurance Company <font size="3" color="red">*</font>&nbsp;</Label>
                                <Select
                                    isClearable={true}
                                    value={this.state.valInsuranceCompany}
                                    options={this.InsuranceCompanyList()}
                                    name="Company"
                                    onChange={this.handleChangeCompany}
                                    isDisabled={this.state.cash_payment == 1 ? true : false}
                                />
                                {this.state.cash_payment == 0 ? this.validator.message('InsuranceCompany', this.state.iCompany, 'required') : null}
                            </Col>
                            <Col md={2}>
                                <Label for="InsurancePlanCode">Plan Code</Label>
                                <Input type="text"
                                    name="PlanCode"
                                    placeholder="Plan Code"
                                    onChange={e => this.setState({ iPlanCode: e.target.value })}
                                    value={this.state.iPlanCode}
                                    className="form-control"
                                    disabled={this.state.cash_payment == 1 ? true : false}

                                />
                            </Col>
                            <Col md={2}>
                                <Label for="InsuranceCompany">Company Name</Label>
                                <Input type="text"
                                    name="InsuranceCompanyName"
                                    placeholder="Company Name"
                                    onChange={e => this.setState({ iCompany: e.target.value })}
                                    value={this.state.iCompany}
                                    className="form-control"
                                    disabled={this.state.cash_payment == 1 ? true : false}
                                />
                            </Col>
                            <Col md={4}>
                                <Label for="InsuranceAddress">Address</Label>
                                <Input type="text"
                                    name="InsuranceAddress"
                                    placeholder="Address"
                                    onChange={e => this.setState({ iAddress: e.target.value })}
                                    value={this.state.iAddress}
                                    className="form-control"
                                    disabled={this.state.cash_payment == 1 ? true : false}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col md={2}>
                                <Label for="InsuranceID">ID#</Label>
                                <Input type="text"
                                    name="InsuranceID"
                                    placeholder="ID"
                                    onChange={e => this.setState({ iId: e.target.value })}
                                    value={this.state.iId}
                                    className="form-control"
                                    disabled={this.state.cash_payment == 1 ? true : false}
                                />
                            </Col>
                            <Col md={2}>
                                <Label for="InsuranceGroupID">Group#</Label>
                                <Input type="text"
                                    name="InsuranceGroup"
                                    placeholder="Group"
                                    onChange={e => this.setState({ iGroup: e.target.value })}
                                    value={this.state.iGroup}
                                    className="form-control"
                                    disabled={this.state.cash_payment == 1 ? true : false}
                                />
                            </Col>


                            <Col md={4}>
                                <Label for="InsuranceInsuredName">Name of Insured/Subscriber <font size="3" color="red">*</font>&nbsp;</Label>
                                <Input type="text"
                                    name="InsuredName"
                                    placeholder="Name of Insured/Subscriber"
                                    onChange={e => this.setState({ iInsuredName: e.target.value })}
                                    value={this.state.iInsuredName}
                                    className="form-control"
                                    disabled={this.state.cash_payment == 1 ? true : false}
                                />
                                {this.state.cash_payment == 0 ? this.validator.message('Name of Insured/Subscriber', this.state.iInsuredName, 'required') : null}
                            </Col>
                            <Col md={2}>
                                <Label for="InsuredDOB">DOB <font size="3" color="red">*</font>&nbsp;</Label>
                                <LSDatePicker
                                    className="form-control white"
                                    disableFuture
                                    id="LSDatePicker_2"
                                    autoOk={true}
                                    views={["year", "month", "date"]}
                                    format="MM-dd-yyyy"
                                    placeholder="MM-DD-YYYY"
                                    variant="inline"
                                    maxDate={new Date()}
                                    value={this.state.selected_InsuredDOB ? this.state.selected_InsuredDOB : null}
                                    onChange={this.handleInsuredDateChange}
                                    KeyboardButtonProps={{ "aria-label": "change date" }}
                                    InputProps={{ disableUnderline: true }}
                                    disabled={this.state.cash_payment == 1 ? true : false}
                                />
                                {this.state.cash_payment == 0 ? this.validator.message('Insured Date of Birth', this.state.InsuredDOB, 'required|InvalidDOB', { messages: { InvalidDOB: 'The Insured date of birth is invalid.' } }) : null}
                            </Col>
                            <Col md={2}>
                                <Label for="InsuredRelationship">Relationship to Subscriber <font size="3" color="red">*</font>&nbsp;</Label>
                                <Select
                                    value={this.state.valInsuredRelationship}
                                    onChange={this.handleChange_InsuredRelationship}
                                    name="InsuredRelationship"
                                    id="InsuredRelationship"
                                    options={this.RelationshipDetailOption()}
                                    isDisabled={this.state.cash_payment == 1 ? true : false}
                                />
                                {this.state.cash_payment == 0 ? this.validator.message('Relationship to Subscriber', this.state.valInsuredRelationship, 'required') : null}
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col md={4}>
                                <Label for="InsuranceDocument">Upload Insurance Documents and one Identity Proof</Label>
                                <Icon.Info size={16} className="fonticon-wrap cpt-icon" data-tip data-for='info' />
                                <ReactTooltip id='info' type='info' place='bottom'>
                                    <span>maximum 3 files can be uploaded<br></br></span>
                                </ReactTooltip>
                                <Input type="file" name="Insurance Document" id="fileupload" onChange={this.onFileChange} key={this.state.fileInputKey || ''} />
                                <FormText color="muted">Only jpg, jpeg, png, pdf file are allowed.</FormText>
                                {/* accept=".jpg, .jpeg, .png, .pdf, .doc, .docx" */}

                                <div className="form-group preview mt-2">
                                    {this.state.InsuranceDocument.length > 0 &&
                                        this.state.InsuranceDocument.map((item, index) => {
                                            return (
                                                <div key={index} className="alert alert-success alert-dismissible fade show" style={{ marginBottom: '.3rem', paddingTop: '.5rem', paddingBottom: '.5rem' }} role="alert">
                                                    {item.name}
                                                    <button type="button" className="close" onClick={() => this.deleteFile(index)} data-dismiss="alert" aria-label="Close" style={{ lineHeight: '.5' }} >
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>

                                            );
                                        })}
                                </div>

                            </Col>



                        </Row>
                        {/* Patient Insurance Info Line 1 Ends Here */}




                        <Row>
                            <Col md={12}>
                                <hr />
                                <div className="pull-right" style={{ "float": "right", marginTop: '50px' }}>
                                    <FormGroup>
                                        <Button
                                            type="reset"
                                            color="danger"
                                            name="order_cancel"
                                            id="_order_cancel"
                                            onClick={this.ResetFields}
                                        >Cancel</Button>
                                        &nbsp;
                                        <Button type="submit" color="primary"
                                            disabled={this.state.isButtonDisabled}
                                            onClick={this.handle_saveAppointment}
                                            name="patient_save">Submit</Button>
                                    </FormGroup>
                                </div>
                            </Col>
                        </Row>

                        {/* Submit buttons */}
                    </CardBody>
                </Card>
            </div>
        )
    }


}

export default PreRegistration